import React, { useState, useEffect } from "react";

//Importar componenetes locales.
import Inbox from "../components/Chats/inbox_components/Inbox";
import Chat from "../components/Chats/chat_components/Chat";
import ClientProfile from "../components/Chats/clientProfile_components/ClientProfile";
import useNewRutaVisitada from "../hooks/useNewRootVisited";

const Chats = ({ ruta, onChangeRuta, socketConnected, setSocketConnected }) => {
  const [sessionsChatSelected, setSessionsChatSelected] = useState([]); //Estado para actualizar las sesiones del chat seleccionado desde NewMessage.jsx.
  const [chatData, setChatData] = useState({}); //Estado para actualizar el objeto con los datos del chat seleccionado desde NewMessage.jsx.

  //Función de callback para extraer los datos del chat seleccionado y
  //pasarlo como prop al componente Chat, y mostrar los datos de ese chat.
  const onChangeChat = (chatSelected, chat) => {
    setSessionsChatSelected(chatSelected); //Actualizar las sesiones del chat seleccionado.
    setChatData(chat[0]); //Actualizar los datos generales del chat seleccionado para extraer el nombre.
    console.log('historial del chat seleccionado', sessionsChatSelected);
    console.log('datos del chat seleccioando', chat[0]);
    console.log('datos del chat seleccioando///////////////////', chat);
  };

  //FUNCIONES PARA MANEJO DE RUTAS
  useNewRutaVisitada(ruta, onChangeRuta);

  return (
    <div className="container-chats__layout">

      {/*-----Contenido del Inbox-----*/}
      <Inbox onChangeChat={onChangeChat} socketConnected={socketConnected} 
      setSocketConnected={setSocketConnected} />

      {/*-----Contenido del Chat-----*/}
      <Chat chatData={chatData} setChatData={setChatData} setSessionsChatSelected = {setSessionsChatSelected} 
      socketConnected={socketConnected} sessionsChatSelected={sessionsChatSelected} />

      {/*-----Contenido del Perfil del Cliente-----*/}
       <ClientProfile chatData={chatData} socketConnected={socketConnected} sessionsChatSelected={sessionsChatSelected}  />
 
    </div>
  );
};

export default Chats;